import { useState } from "react";
import { Calculator } from "lucide-react";

import FundingCta from "@/components/FundingCta";
import SbaCalculatorForm from "@/components/SbaCalculatorForm";
import { parseSbaQuery } from "@/lib/sbaMath";

export default function SbaCalculator() {
  // Buyers view this page inside the left sidebar shell, so fill the wider column.
  // Full width for every role — see PageShell in components/interior-page.tsx.
  const shellWidth = "w-full";
  // A shared "Copy link" scenario arrives as query params; read once on mount.
  const [shared] = useState(() => parseSbaQuery(window.location.search));

  return (
    <div className="public-stage pb-10">
      <div className={`${shellWidth} px-4 py-8 sm:px-6 lg:px-8`}>
        {/* Header — same Dark · Gold hero as Deal CRM and the other interior pages */}
        <section className="public-hero-shell mb-7 rounded-[1.85rem] px-6 py-7 shadow-glow sm:px-8">
          <div className="public-grid-lattice absolute inset-0 opacity-45" />
          <div className="absolute -right-14 top-0 h-40 w-40 rounded-full bg-white/30 blur-3xl" />
          <div className="relative z-10">
            <div className="public-pill">
              <Calculator className="h-3.5 w-3.5" />
              SBA Calculator
            </div>
            <h1 className="mt-4 font-display text-3xl leading-tight text-foreground sm:text-4xl">
              SBA <span className="text-gradient">Acquisition Calculator</span>
            </h1>
            <p className="mt-2 max-w-2xl text-sm leading-7 text-muted-foreground sm:text-base">
              Model the financing on a business acquisition — debt service, cash required, DSCR, and
              SBA 7(a) eligibility update live as you type.
            </p>
          </div>
        </section>

        <SbaCalculatorForm initialValues={shared} shareable />
        <FundingCta className="mt-6" />
      </div>
    </div>
  );
}
